import * as navigationConfig from './navigation';

export const BUILDER_DESKTOP_COMPONENT_START_WIDTH = 768;
export const BUILDER_MQ_IS_MOBILE_SIZE = `(max-width: ${BUILDER_DESKTOP_COMPONENT_START_WIDTH - 1}px)`;

export { navigationConfig };
